/**
 * Manage Coins.
 *
 * This creates, and updates the coins throughout the world.
 * @type {Object}
 */
Game.Utils.ManageCoins = {

	coins: [],

	coins_total: 0,

	SIZE: 8,

	/**
	 * Initialize the coin manager.
	 *
	 * @param  {Object} map_layer The Tiled layer used to store map properties.
	 * @param  {[type]} tile_id   The texture id for the tile used to display coins.
	 * @param  {[type]} layer     The layer to add the coins to.
	 */
	init: function( map_layer, tile_id, layer ) {

		this.reset();

		// Get the 2-dimensional tiles array for this layer.
		var d = map_layer.map.layers[map_layer.index].data;

		for ( var i = 0; i < d.length; i++ ) {

			for ( var j = 0; j < d[i].length; j++ ) {

				var t = d[i][j];

				if ( tile_id === t.index ) {

					var x = j * Game.Utils.Map.TILE_SIZE;
					var y = i * Game.Utils.Map.TILE_SIZE;

					var coin = new Game.Prefabs.Coin( game, x, y, layer );

					this.coins.push( coin );

				}

			}

		}

		this.coins_total = this.coins.length;

		console.log( 'Total coins', this.coins.length );

	},


	/**
	 * Check the coins to see if the player is overlapping it.
	 *
	 * @param  {[type]} player [description]
	 * @return {[type]}        [description]
	 */
	update: function( player ) {

		// If player is disabled for some reason then don't check coins.
		if ( ! player.alive ) {
			return;
		}

		for ( var c = 0; c < this.coins.length; c++ ) {

			var coin = this.coins[c];

			if ( player.x > coin.x - this.SIZE && player.x < coin.x + this.SIZE ) {
				if ( player.body.bottom > coin.y && player.body.top < coin.y ) {

					coin.collect();
					this.coins.splice( c, 1 );

					Game.Utils.Hud.addCoin();

					Game.Utils.Inventory.collect( this.getKey( coin ) );
					Game.Utils.Inventory.collect( 'coin/count', Game.Utils.Hud.coins.getValue() );

				}
			}

		}

	},


	lotsOfCoins: function() {

		for( var i = 0; i < 300; i ++ ) {

			Game.Utils.Hud.addCoin();

		};

	},


	getKey: function( coin ) {

		return 'coin/world-1/' + Game.Utils.Map.tile_coord( coin.x ) + ':' + Game.Utils.Map.tile_coord( coin.y );

	},


	getTotal: function() {

		return this.coins_total;

	},


	getRemaining: function() {

		return this.coins.length;

	},


	/**
	 * Reset existing coins and delete the instances.
	 *
	 * @return {[type]} [description]
	 */
	reset: function() {

		for ( var c = 0; c < this.coins.length; c++ ) {

			var coin = this.coins[c];
			coin.kill();

		}

		this.coins = [];

		this.coins_total = 0;

	},

};
